module.exports = __webpack_public_path__ + "img/OverviewList.1e42fa57.svg";